module.exports = __webpack_public_path__ + "img/mnlx@2x.61bc60cb.png";